'use strict';

export function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
  'ngInject';

  var state;
  return {
    // Add authorization token to headers
    request(config) {
      config.headers = config.headers || {};
      if($cookies.get('token') && Util.isSameOrigin(config.url)) {
        config.headers.Authorization = `Bearer ${$cookies.get('token')}`;
      }
      return config;
    },

    // Intercept 401s and redirect you to login
    responseError(response) {
      if(response.status === 401 && response.config.url !== '/auth/local') {
        var data = response.data;
        if(typeof data === 'string' && response.headers()['content-type'] === 'application/json; charset=utf-8'){
          data = JSON.parse(data);
        }
        (state || (state = $injector.get('$state')))
          .go('signup', {message: data.message}, {reload: true});
        // remove any stale tokens
        $cookies.remove('token');
      }
      return $q.reject(response);
    }
  };
}
